export function parseCurrencyString(value: string) {
  if (!value) return "";
  let cleaned = value.replace(/\s/g, "");
  cleaned = cleaned.replace(/[^0-9.,]/g, "");
  if (cleaned.includes(",")) {
    cleaned = cleaned.replace(/\./g, "");
    cleaned = cleaned.replace(/,/g, ".");
    return cleaned;
  }
  cleaned = cleaned.replace(/[^0-9.]/g, "");
  return cleaned;
}
